require("!!../../../node_modules/happypack/loader.js!./index.ts");